import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const navItems = [
  { path: '/', num: '01', label: 'Overview' },
  { path: '/agreement', num: '02', label: 'Agreement' },
  { path: '/documents', num: '03', label: 'Documents', badge: 3 },
  { path: '/readiness', num: '04', label: 'Readiness Form' },
  { path: '/payments', num: '05', label: 'Payments' },
];

const Sidebar = ({ isOpen, setisOpen }) => {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2 className="sidebar-title">CASE FILE - TWINOXIS</h2>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={() => setisOpen(false)}
          >
            <span className="nav-num">{item.num}</span>
            <span>{item.label}</span>
            {item.badge && <span className="badge">{item.badge}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
